import { render, staticRenderFns } from "./loginModal.vue?vue&type=template&id=0b70202b&scoped=true"
import script from "./loginModal.vue?vue&type=script&lang=js"
export * from "./loginModal.vue?vue&type=script&lang=js"
import style0 from "./loginModal.vue?vue&type=style&index=0&id=0b70202b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70202b",
  null
  
)

export default component.exports